<template lang="html">
    <div class="bagClub" :class="{ active: active }">
        <div @click.prevent="makeActive" v-on-clickaway="cancel">
            <span class="handle">
                <img v-if="!active" src="@/assets/arrows-up-down-dark-white.svg" />
                <img v-else src="@/assets/arrows-up-down-dark-green.svg" />
            </span>

            <input
                :disabled="inputDisabled < 1"
                @focus="focusClub"
                @input="saveValue"
                autocomplete="nope"
                type="text"
                ref="bagItem"
                minlength="1"
                required
                maxlength="255"
                v-model="form.club"
            />
            <input
                :disabled="inputDisabled < 1"
                @focus="focusModel"
                @input="saveValue"
                autocomplete="nope"
                type="text"
                minlength="1"
                required
                maxlength="255"
                v-model="form.name"
            />

            <img @click.prevent="openDelete" class="bin" src="~@/assets/icons/bin.svg" />

            <div class="error" v-if="form.errors.any()">Please ensure you have added your club</div>
        </div>

        <!--<form class="saveClub" v-if="open" :data-id="club.id">

          <button @click.prevent.self="updateClub" :disabled="form.busy" class="button half" type="button" name="button">Update club</button>
          <button @click.prevent.self="cancel" class="button half cancel" type="button" name="button">Cancel</button>
      </form>-->

        <form class="deleteClub" v-if="deleteOpen">
            <p>Are you sure you want to delete this club?</p>
            <button
                :disabled="form.busy"
                @click.prevent.self="deleteClub"
                class="button half"
                type="button"
                name="button"
            >
                Yes, delete
            </button>
            <button
                @click.prevent.self="cancel"
                class="button half cancel"
                type="button"
                name="button"
            >
                No, cancel
            </button>
        </form>
    </div>
</template>

<script>
import { debounce } from "debounce";
import { mixin as clickaway } from "vue-clickaway";
import { Form } from "vform";
export default {
    name: "bag-list-item",
    mixins: [clickaway],
    props: {
        club: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            active: false,
            open: false,
            deleteOpen: false,
            inputDisabled: 0,
            form: new Form({
                id: "",
                user_id: "",
                club: "",
                name: "",
                order: "",
            }),
        };
    },
    created() {
        this.form.fill(this.club);
    },
    methods: {
        saveValue: debounce(function () {
            this.updateClub();
        }, 500),
        makeActive() {
            this.active = true;
            this.open = true;
            this.inputDisabled++;
        },
        focusClub() {
            if (this.form.club == "Club...") {
                this.form.club = "";
            }
        },
        focusModel() {
            if (this.form.name == "Model...") {
                this.form.name = "";
            }
        },
        updateClub() {
            this.form.put("/bag/" + this.club.id).then((response) => {
                this.$store.state.user.bags = response.data;
            });
        },
        openDelete() {
            this.deleteOpen = true;
        },
        deleteClub() {
            this.form.delete("/bag/" + this.club.id).then(() => {
                this.$notify({
                    duration: 1000,
                    text: "Your bag has been updated!",
                });
            });

            this.$store.dispatch("deleteBagItem", this.club);
        },
        cancel() {
            this.open = false;
            this.active = false;
            this.deleteOpen = false;
            this.inputDisabled = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.bagClub {
    padding: 10px;
    color: white;
    border-bottom: 1px solid $darkGrey_0;
    position: relative;
    background: $green_0;
    padding-top: 0px;
    padding-bottom: 0px;
    //height:39px;
    .surround {
        pointer-events: none;
        &.allowed {
            pointer-events: all;
        }
    }

    i {
        float: right;
        text-align: right;
    }

    .error {
        background: #ffbcbc;
        padding: 7px;
        line-height: 1.5;
        border-radius: 3px;
        display: block;
        margin-top: 10px;
        font-size: 0.8rem;
        text-align: center;
        border: 1px solid red;
        color: red;
    }

    &.active {
        background: white;
        margin-left: -20px;
        margin-top: -1px;
        //padding-top:11px;
        padding-left: 30px;
        width: calc(100% + 40px);
        padding-right: 30px;

        input {
            color: $green_0;
        }

        .handle {
            left: 9px;
        }

        .bin {
            display: block;
        }
    }

    .handle {
        position: absolute;

        left: -11px;
        top: 0px;
        height: 100%;
        padding-left: 13px;
        padding-right: 20px;
        //padding-top: 12px;
        display: block;
        padding-top: 11px;
    }

    .bin {
        position: absolute;
        right: 20px;
        top: 14px;
        display: none;
    }

    input {
        background: none;
        width: 30%;
        display: inline-block;
        border: 0px;
        font-size: 16px;
        color: white;
        font-family: canada-type-gibson, sans-serif;
        font-weight: 200;
        padding-top: 11px;
        padding-bottom: 11px;
        &:focus {
            outline: 0;
        }
        &:nth-of-type(1) {
            margin-left: 10px;
        }
        &:nth-of-type(2) {
            width: calc(70% - 10px);
        }
        &:disabled {
            opacity: 1;
            -webkit-text-fill-color: white;
        }
    }

    .saveClub,
    .deleteClub {
        background: white;
        padding: 20px;
        position: fixed;
        bottom: 0px;
        width: 100%;
        left: 0px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        box-shadow: 0px -20px 10px rgba(0, 0, 0, 0.1);
        z-index: 3;
        p {
            margin-bottom: 20px;
            text-align: center;
            color: $green_0;
        }
    }
    .deleteClub {
        z-index: 4;
    }
}
</style>
